var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelpIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: "50%",
    cy: "50%",
    r: 9,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.81812 10.909C1.81812 5.89084 5.89084 1.81812 10.909 1.81812C15.9272 1.81812 19.9999 5.89084 19.9999 10.909C19.9999 15.9272 15.9272 19.9999 10.909 19.9999C5.89084 19.9999 1.81812 15.9272 1.81812 10.909ZM11.8181 14.5454V16.3636H9.99993V14.5454H11.8181ZM10.909 18.1818C6.89993 18.1818 3.6363 14.9181 3.6363 10.909C3.6363 6.89993 6.89993 3.6363 10.909 3.6363C14.9181 3.6363 18.1818 6.89993 18.1818 10.909C18.1818 14.9181 14.9181 18.1818 10.909 18.1818ZM7.27266 9.09084C7.27266 7.08175 8.89993 5.45448 10.909 5.45448C12.9181 5.45448 14.5454 7.08175 14.5454 9.09084C14.5454 10.2571 13.8272 10.8848 13.1279 11.4959C12.4645 12.0756 11.8181 12.6405 11.8181 13.6363H9.99993C9.99993 11.9806 10.8564 11.3241 11.6094 10.7469C12.2001 10.2941 12.7272 9.89013 12.7272 9.09084C12.7272 8.09084 11.909 7.27266 10.909 7.27266C9.90902 7.27266 9.09084 8.09084 9.09084 9.09084H7.27266Z",
    fill: "black",
    fillOpacity: 0.54
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpIcon);
export default __webpack_public_path__ + "static/media/HelpIcon.587d3b29ea5966d22701102cc0d31016.svg";
export { ForwardRef as ReactComponent };